<template>
		<el-card class="box-card" shadow="hover">
		  <el-tabs type="card" @tab-click="tabclick">
			<el-tab-pane label="物流信息" name="0">
				<div :style="{ height: `${tabheight}px`, 'overflow-y': 'auto' }">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="快递公司">
							<span>{{expresscom}}</span>
						</el-form-item>
						<el-form-item label="快递单号">
							<span>{{expressid}}</span>
						</el-form-item>
					</el-form>
					<el-timeline :reverse="reverse">
						<el-timeline-item v-for="(activity, index) in wllist" :key="index" :timestamp="activity.createtime">
							{{ activity.context }}
						</el-timeline-item>
					</el-timeline>
				</div>
			</el-tab-pane>
			<el-tab-pane label="拦截日志" name="1">
				<div :style="{ height: `${tabheight}px`, 'overflow-y': 'auto' }">
				<el-timeline :reverse="reverse">
					<el-timeline-item v-for="(activity, index) in kflist" :key="index" :timestamp="activity.createtime">
						{{ activity.context }}
					</el-timeline-item>
				</el-timeline>
				</div>
			</el-tab-pane>
			<el-tab-pane label="订单日志" name="2">
				<div :style="{ height: `${tabheight}px`, 'overflow-y': 'auto' }">
				<el-timeline :reverse="reverse">
					<el-timeline-item v-for="(activity, index) in handlelist" :key="index" :timestamp="activity.createtime">
					<span style="color:#b0b0b0;font-size:10pt;">{{ activity.u_account }}</span>	<span>{{ activity.context }}</span>
					</el-timeline-item>
				</el-timeline>
				</div>
			</el-tab-pane>
		  </el-tabs>
	  </el-card>
</template>

<script>
export default {
	data() {
		return {
			pkval:'',
			wllist:[],
			kflist:[],
			handlelist:[],
			reverse: true,
			tabheight:260,
			expressid:'',
			orderinfo:{},
			expresscom:''
		}
	},
	methods: {
		init(param){
			if(param.orderinfo!=undefined){
				this.orderinfo=param.orderinfo;
				this.pkval=param.orderinfo.p_pkval;
				this.expressid=this.orderinfo.express.expressid;
				this.expresscom=this.orderinfo.express.expresscom;
			}
				
			this.getwl();
		},
		//获取物流
		getwl() {
			var that = this;
			var paraminfo = {
				handtype: 1,
				orderid: this.pkval
			};
			this.$apipost.get.getwl({ paraminfo: paraminfo }).then(res => {
				if(res.orderlist!=undefined){
					if(res.orderlist.length>0){
						if (res.orderlist[0].list != undefined) {
							that.wllist =res.orderlist[0].list;
						}
						if (that.wllist.length == 0) {
							that.wllist = [{ time: '', context: '暂无物流' }];
						}
					}
				}
			});
		},
		//物流选项卡切换
		tabclick(e){
			if(e.index=='1'){
				if(this.kflist.length==0)
					this.getkflist();
			}
			if(e.index=='2')
			{
				if(this.handlelist.length==0)
					this.GetHandleLog();
			}
		},
		//获取客服日志
		getkflist(){
			var that=this;
			this.$apipost.get.Getkflist({ pkval: this.pkval }).then(res => {
				if (res.list.length > 0) {
					that.kflist = res.list;
				} else {
					that.kflist.push({ context: '无记录', createtime: '' });
				}
			});
		},
		GetHandleLog(){
			var that=this;
			this.$apipost.get.GetHandleLog({ pkval: this.pkval }).then(res => {
				if (res.list.length > 0) {
					that.handlelist = res.list;
				} else {
					that.handlelist.push({ context: '无记录', createtime: '',u_account:'' });
				}
			});
		}
	}
}
</script>

<style>
</style>
